<nav class="white z-depth-0">
  <div class="nav-wrapper container ">
    <span class="grey-text text-darken-1">
      <i class="material-icons sidenav-trigger" data-target="side-menu">menu</i>
    </span>
    <ul id="nav-mobile" class="right hide-on-med-and-down">
      <li
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        *ngFor="let route of routes"
      >
        <a class="grey-text text-darken-4" routerLink="{{ route.path }}">{{
          route.name
        }}</a>
      </li>
    </ul>
  </div>
</nav>

<ul id="side-menu" class="sidenav">
  <li class="center-align">
    <div class="user-view">
      <div class="background yellow lighten-1">
        <img
          style="opacity: 0.2;"
          src="https://materializecss.com/images/office.jpg"
        />
      </div>
      <a
        ><img
          style="margin: auto;"
          class="circle"
          src="{{
            userComponent
              ? userComponent.photoURL
              : 'https://image.flaticon.com/icons/svg/149/149452.svg'
          }}"
      /></a>
      <a href="#name"
        ><span
          class="grey-text text-darken-4 name"
          style="font-size: 1.5rem;"
          >{{ userComponent ? userComponent.displayName : "Guest" }}</span
        ></a
      >
      <a href="#email"
        ><span class="grey-text text-darken-1 email">{{
          userComponent ? userComponent.email : "Guest"
        }}</span></a
      >
    </div>
  </li>
  <span *ngFor="let route of routes">
    <li>
      <a class="subheader">{{ route.name }}</a>
    </li>
    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <a class="grey-text text-darken-4" routerLink="{{ route.path }}">
        {{ route.desc }}
      </a>
    </li>
    <li><div class="divider"></div></li>
  </span>
  <li *ngIf="isLoggedin">
    <a class="waves-effect waves-grey btn-flat sign-out" (click)="signOut()"
      ><i style="font-size: 1.6rem;" class="material-icons left">exit_to_app</i
      >Sign Out</a
    >
  </li>
  <li *ngIf="!isLoggedin">
    <a
      class="waves-effect waves-grey btn-flat center-align sign-in"
      (click)="signIn()"
      >Sign In</a
    >
  </li>
</ul>
<div class="container">
  <router-outlet></router-outlet>
</div>
